var map = {
	"./arg.svg": 2324,
	"./aus.svg": 2325,
	"./bel.svg": 2326,
	"./bra.svg": 2327,
	"./can.svg": 2328,
	"./cmr.svg": 2329,
	"./crc.svg": 2330,
	"./cro.svg": 2331,
	"./den.svg": 2332,
	"./ecu.svg": 2333,
	"./eng.svg": 2334,
	"./esp.svg": 2335,
	"./fra.svg": 2336,
	"./ger.svg": 2337,
	"./gha.svg": 2338,
	"./irn.svg": 2339,
	"./jpn.svg": 2340,
	"./kor.svg": 2341,
	"./ksa.svg": 2342,
	"./mar.svg": 2343,
	"./mex.svg": 2344,
	"./ned.svg": 2345,
	"./pol.svg": 2346,
	"./por.svg": 2347,
	"./qat.svg": 2348,
	"./sen.svg": 2349,
	"./srb.svg": 2350,
	"./sui.svg": 2351,
	"./tun.svg": 2352,
	"./uru.svg": 2353,
	"./usa.svg": 2354,
	"./wal.svg": 2355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;